export const VERSION = "__VERSION__";
